module.exports = __webpack_public_path__ + "media/images/category/dummy/accessory05-e543748655e42fb87faa1256c6490afd.jpg";